import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ConfigContext from "../../context/config/ConfigContext";
import NavigationContext from "../../context/navigation/NavigationContext";
import usePageTitle from "../../hooks/usePageTitle";

const ChangePassword = (props) => {
  const configContext = useContext(ConfigContext);
  const navigationContext = useContext(NavigationContext);
  const { getConfigValueByName } = configContext;
  const { setFieldRefs } = navigationContext;

  // const { existingpassword, newpassword, confirmPassword } = props.password;
  const { passwordChange, onBlur } = props;
  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Change Password",
  });

  const existingpasswordRef = useRef(null);
  const newpasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);

  const [labels, setLabels] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  useEffect(() => {
    setFieldRefs({
      change_password: {
        existingpassword: existingpasswordRef,
        newpassword: newpasswordRef,
        confirmPassword: confirmPasswordRef,
      },
    });
    let currentPassword = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.currentPassword"
    );
    let newPassword = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.newPassword"
    );
    let confirmNewPassword = getConfigValueByName(
      "generalConfig",
      "Label",
      "label.confirmNewPassword"
    );
    setLabels({
      ...labels,
      currentPassword,
      newPassword,
      confirmNewPassword,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const { existingpasswordRef, newpasswordRef, confirmPasswordRef } = refs;
  // const passwordChange = (e) => {
  //   props.passwordChange(e);
  //   if (newpassword && e.target.name === "confirmPassword") {
  //     clearAlerts();
  //     if (newpassword !== e.target.value) {
  //       setAlert("Passwords do not match", "danger");
  //     }
  //   }
  //   if (confirmPassword && e.target.name === "newpassword") {
  //     clearAlerts();
  //     if (confirmPassword !== e.target.value) {
  //       setAlert("Passwords do not match", "danger");
  //     }
  //   }
  // };

  return (
    <Fragment>
      <div
        id="passwordForm"
        className="password__formBody"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <form autoComplete="off" noValidate>
          <div className="password__formBody__formGroup">
            <label htmlFor="existingpassword">
              {labels.currentPassword}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="password"
              name="existingpassword"
              className="form-control"
              placeholder={labels.currentPassword}
              onChange={passwordChange}
              ref={existingpasswordRef}
              onBlur={onBlur}
              autoComplete="off"
            />
          </div>
          <div className="password__formBody__formGroup">
            <label htmlFor="newpassword">
              {labels.newPassword}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="password"
              name="newpassword"
              className="form-control"
              placeholder={labels.newPassword}
              onChange={passwordChange}
              ref={newpasswordRef}
              onBlur={onBlur}
              autoComplete="new-password"
            />
          </div>
          <div className="password__formBody__formGroup">
            <label htmlFor="confirmPassword">
              {labels.confirmNewPassword}
              <span className="required" aria-label="Input required">
                (*Required)
              </span>
              :{" "}
            </label>
            <input
              type="password"
              name="confirmPassword"
              className="form-control"
              placeholder={labels.confirmNewPassword}
              onChange={passwordChange}
              ref={confirmPasswordRef}
              onBlur={onBlur}
              autoComplete="new-password"
            />
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default ChangePassword;
